// extracted by mini-css-extract-plugin
module.exports = {"container":"WorkingLayout_container__28hGv","headline":"WorkingLayout_headline__5mBxP","description":"WorkingLayout_description__23pBZ","loader":"WorkingLayout_loader__3fPHW"};